<template class="hour-balance">
    <template v-for="value in timeTypes" :key="'timeType' + value.id">
        <PlanbordGridCell v-show="isTimeTypeEnabled(value.id)" balance info>-</PlanbordGridCell>
    </template>
    <template v-for="value in leaveOverviews" :key="'overview' + value.id!">
        <PlanbordGridCell v-show="isOverviewEnabled(value.id!)" balance info>-</PlanbordGridCell>
    </template>
    <template v-for="count in deploymentCounts" :key="'count' + count.configurationId">
        <PlanbordGridCell v-show="isCountEnabled(count.configurationId)" balance info>-</PlanbordGridCell>
    </template>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import {BalanceFilterType} from '@/components/FilterBar/types';
    import {TimeType, LeaveOverview} from '@cquential/api';
    import {DeploymentCountsOfResourceOrCompany} from '@/components/types';

    @Component({
        components: {
            PlanbordGridCell,
        },
    })
    export default class BalanceCompanyOrOtherRoster extends Vue {
        @Prop({required: true}) public timeTypes!: Record<number, TimeType>;
        @Prop({required: true}) public enabledBalanceAndCountDisplays!: Record<BalanceFilterType, Record<number, boolean>>;
        @Prop({required: true}) public leaveOverviews!: LeaveOverview[];
        @Prop({required: true}) public deploymentCounts!: DeploymentCountsOfResourceOrCompany[];

        public isTimeTypeEnabled(id: number): boolean {
            return this.enabledBalanceAndCountDisplays[BalanceFilterType.HourBalance][id] ?? false;
        }

        public isOverviewEnabled(id: number): boolean {
            return this.enabledBalanceAndCountDisplays[BalanceFilterType.LeaveOverview][id] ?? false;
        }

        public isCountEnabled(id: number): boolean {
            return this.enabledBalanceAndCountDisplays[BalanceFilterType.DeploymentCount][id] ?? false;
        }
    }
</script>

<style lang="scss" scoped>
    .tbody-td {
        color: #000;
        font-weight: 500;
    }

    .tfoot-td {
        color: #000;
        font-weight: bold;
        padding: .4rem .3rem;
    }
</style>
